import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BasketIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M22 9.98H17.21L12.83 3.42C12.64 3.14 12.32 3 12 3C11.68 3 11.36 3.14 11.17 3.43L6.79 9.98H2C1.45 9.98 1 10.43 1 10.98C1 11.07 1.01 11.16 1.04 11.25L3.58 20.52C3.81 21.36 4.58 21.98 5.5 21.98H18.5C19.42 21.98 20.19 21.36 20.43 20.52L22.97 11.25L23 10.98C23 10.43 22.55 9.98 22 9.98ZM12 5.78L14.8 9.98H9.2L12 5.78ZM18.5 19.98L5.51 19.99L3.31 11.98H20.7L18.5 19.98ZM12 13.98C10.9 13.98 10 14.88 10 15.98C10 17.08 10.9 17.98 12 17.98C13.1 17.98 14 17.08 14 15.98C14 14.88 13.1 13.98 12 13.98Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
